import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'formlabs-web-components/Link';

import ProductDetailHeader from '../../ProductDetailHeader';

const RootStep = ({
  amount,
  attributes,
  baseUrl,
  bundleOptions,
  category,
  media,
  name,
  price,
  sku,
  showAvailability
}) => {
  const [t] = useTranslation();

  return (
    <ProductDetailHeader
      actions={
        <div style={{ gridArea: 'actions' }}>
          <Button to="/package/">{t('Configure Now')}</Button>
        </div>
      }
      amount={amount}
      attributes={attributes}
      baseUrl={baseUrl}
      bundleOptions={bundleOptions}
      category={category}
      media={media}
      name={name}
      price={price}
      sku={sku}
      showAvailability={showAvailability}
      isMinPrice
    />
  );
};

export default RootStep;
